function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(-3151.127 -3247.416)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M3176.827,3247.708a8.526,8.526,0,0,1,5.756.478h0a8.543,8.543,0,0,0,7.089,0h0a8.547,8.547,0,0,1,10.5,2.814h0a8.537,8.537,0,0,0,6.139,3.544h0a8.546,8.546,0,0,1,7.687,7.687h0a8.538,8.538,0,0,0,3.544,6.139h0a8.543,8.543,0,0,1,2.814,10.5h0a8.543,8.543,0,0,0,0,7.089h0a8.542,8.542,0,0,1-2.814,10.5h0A8.538,8.538,0,0,0,3214,3302.6h0a8.543,8.543,0,0,1-7.687,7.687h0a8.546,8.546,0,0,0-6.139,3.544h0a8.544,8.544,0,0,1-10.5,2.814h0a8.543,8.543,0,0,0-7.089,0h0a8.542,8.542,0,0,1-10.5-2.814h0a8.547,8.547,0,0,0-6.139-3.544h0a8.543,8.543,0,0,1-7.687-7.687h0a8.54,8.54,0,0,0-3.544-6.139h0a8.542,8.542,0,0,1-2.814-10.5h0a8.543,8.543,0,0,0,0-7.089h0a8.543,8.543,0,0,1,2.814-10.5h0a8.54,8.54,0,0,0,3.544-6.139h0a8.545,8.545,0,0,1,7.687-7.687h0a8.539,8.539,0,0,0,6.139-3.544h0A8.525,8.525,0,0,1,3176.827,3247.708Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  cx: 29.15,
  cy: 29.15,
  r: 29.15,
  transform: "translate(3156.978 3253.266)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M3200.636,3289.456h-2.54v-1.188a1.144,1.144,0,0,0-1.153-.982v-10.9a1.793,1.793,0,0,0-3.586,0v10.9a1.144,1.144,0,0,0-1.154.982v1.188h-2.54a1.057,1.057,0,0,0-1.057,1.057v6.985a1.058,1.058,0,0,0,1.057,1.057h10.974a1.057,1.057,0,0,0,1.057-1.057v-6.985A1.058,1.058,0,0,0,3200.636,3289.456Zm-3.62,0h-3.734v-.892a.511.511,0,0,1,.282-.44,1.793,1.793,0,0,0,3.171,0,.512.512,0,0,1,.281.44v.892Zm-24.45-22.775a3.958,3.958,0,1,1,3.958,3.959A3.958,3.958,0,0,1,3172.566,3266.681Zm18.625,0a3.958,3.958,0,1,1,3.958,3.959A3.958,3.958,0,0,1,3191.191,3266.681ZM3187,3279.757a1.7,1.7,0,0,1-1.7,1.7h-6.325a1.7,1.7,0,0,1-1.391-.722l-3.161-4.491a1.7,1.7,0,0,1,2.783-1.959l2.652,3.769h5.442A1.7,1.7,0,0,1,3187,3279.757Zm-4.466,19.65a2.13,2.13,0,0,1-4.19.768l-1.781-10.756-1.782,10.756a2.13,2.13,0,1,1-4.19-.768l1.83-11.05,0-12.855a4.057,4.057,0,0,1,8.114,0v2.154h-.253l-2.555-3.708a2.292,2.292,0,0,0-3.279-.44,2.137,2.137,0,0,0-.455,3.124l3.1,4.526a2.12,2.12,0,0,0,1.884.954h1.761l0,6.436Zm8.391-17.949h-4.036a2.244,2.244,0,0,0,0-3.4h4.034V3275.5a4.049,4.049,0,1,1,8.1,0l0,13.546h-.519v-.78a1.393,1.393,0,0,0-.847-1.28v-10.666a2.507,2.507,0,0,0-5.015,0v10.666a1.392,1.392,0,0,0-.847,1.28v.78h-.864Zm-1.268,17.5h3.776l-.2,1.212a2.129,2.129,0,1,1-4.189-.768l.09-.542A1.449,1.449,0,0,0,3189.662,3298.963Zm11.328.444a2.129,2.129,0,1,1-4.189.768l-.2-1.212h4.036a1.463,1.463,0,0,0,.276-.026Z",
  fill: "#fbb03b"
})));

var SvgTeamworkOn = function SvgTeamworkOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeamworkOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teamwork-on.d25d6a33.svg";
export { ForwardRef as ReactComponent };